function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $5294278fb5cc815e$exports = require("./intlStrings.main.js");
var $68Tdx$internationalizeddate = require("@internationalized/date");
var $68Tdx$internationalizedstring = require("@internationalized/string");
var $68Tdx$reactstatelyform = require("@react-stately/form");
var $68Tdx$react = require("react");
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "getValidationResult", function () {
  return $50d5d6a623389320$export$f18627323ab57ac0;
});
$parcel$export(module.exports, "getFormatOptions", function () {
  return $50d5d6a623389320$export$7e319ea407e63bc0;
});
$parcel$export(module.exports, "getRangeValidationResult", function () {
  return $50d5d6a623389320$export$80ff8fc0ae339c13;
});
$parcel$export(module.exports, "getPlaceholderTime", function () {
  return $50d5d6a623389320$export$c5221a78ef73c5e9;
});
$parcel$export(module.exports, "convertValue", function () {
  return $50d5d6a623389320$export$61a490a80c552550;
});
$parcel$export(module.exports, "createPlaceholderDate", function () {
  return $50d5d6a623389320$export$66aa2b09de4b1ea5;
});
$parcel$export(module.exports, "useDefaultProps", function () {
  return $50d5d6a623389320$export$2440da353cedad43;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $50d5d6a623389320$var$dictionary = new (0, $68Tdx$internationalizedstring.LocalizedStringDictionary)((0, $parcel$interopDefault($5294278fb5cc815e$exports)));
function $50d5d6a623389320$var$getLocale() {
  // Match browser language setting here, NOT react-aria's I18nProvider, so that we match other browser-provided
  // validation messages, which to not respect our provider's language.
  // @ts-ignore
  return typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
}
function $50d5d6a623389320$export$f18627323ab57ac0(value, minValue, maxValue, isDateUnavailable, options) {
  var rangeOverflow = value != null && maxValue != null && value.compare(maxValue) > 0;
  var rangeUnderflow = value != null && minValue != null && value.compare(minValue) < 0;
  var isUnavailable = value != null && (isDateUnavailable === null || isDateUnavailable === void 0 ? void 0 : isDateUnavailable(value)) || false;
  var isInvalid = rangeOverflow || rangeUnderflow || isUnavailable;
  var errors = [];
  if (isInvalid) {
    var locale = $50d5d6a623389320$var$getLocale();
    var strings = (0, $68Tdx$internationalizedstring.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/datepicker') || $50d5d6a623389320$var$dictionary;
    var formatter = new (0, $68Tdx$internationalizedstring.LocalizedStringFormatter)(locale, strings);
    var dateFormatter = new (0, $68Tdx$internationalizeddate.DateFormatter)(locale, $50d5d6a623389320$export$7e319ea407e63bc0({}, options));
    var timeZone = dateFormatter.resolvedOptions().timeZone;
    if (rangeUnderflow && minValue != null) errors.push(formatter.format('rangeUnderflow', {
      minValue: dateFormatter.format(minValue.toDate(timeZone))
    }));
    if (rangeOverflow && maxValue != null) errors.push(formatter.format('rangeOverflow', {
      maxValue: dateFormatter.format(maxValue.toDate(timeZone))
    }));
    if (isUnavailable) errors.push(formatter.format('unavailableDate'));
  }
  return {
    isInvalid: isInvalid,
    validationErrors: errors,
    validationDetails: {
      badInput: isUnavailable,
      customError: false,
      patternMismatch: false,
      rangeOverflow: rangeOverflow,
      rangeUnderflow: rangeUnderflow,
      stepMismatch: false,
      tooLong: false,
      tooShort: false,
      typeMismatch: false,
      valueMissing: false,
      valid: !isInvalid
    }
  };
}
function $50d5d6a623389320$export$80ff8fc0ae339c13(value, minValue, maxValue, isDateUnavailable, options) {
  var _value_start;
  var startValidation = $50d5d6a623389320$export$f18627323ab57ac0((_value_start = value === null || value === void 0 ? void 0 : value.start) !== null && _value_start !== void 0 ? _value_start : null, minValue, maxValue, isDateUnavailable, options);
  var _value_end;
  var endValidation = $50d5d6a623389320$export$f18627323ab57ac0((_value_end = value === null || value === void 0 ? void 0 : value.end) !== null && _value_end !== void 0 ? _value_end : null, minValue, maxValue, isDateUnavailable, options);
  var result = (0, $68Tdx$reactstatelyform.mergeValidation)(startValidation, endValidation);
  if ((value === null || value === void 0 ? void 0 : value.end) != null && value.start != null && value.end.compare(value.start) < 0) {
    var strings = (0, $68Tdx$internationalizedstring.LocalizedStringDictionary).getGlobalDictionaryForPackage('@react-stately/datepicker') || $50d5d6a623389320$var$dictionary;
    result = (0, $68Tdx$reactstatelyform.mergeValidation)(result, {
      isInvalid: true,
      validationErrors: [strings.getStringForLocale('rangeReversed', $50d5d6a623389320$var$getLocale())],
      validationDetails: _objectSpread(_objectSpread({}, (0, $68Tdx$reactstatelyform.VALID_VALIDITY_STATE)), {}, {
        rangeUnderflow: true,
        rangeOverflow: true,
        valid: false
      })
    });
  }
  return result;
}
var $50d5d6a623389320$var$DEFAULT_FIELD_OPTIONS = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit'
};
var $50d5d6a623389320$var$TWO_DIGIT_FIELD_OPTIONS = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
};
function $50d5d6a623389320$export$7e319ea407e63bc0(fieldOptions, options) {
  var defaultFieldOptions = options.shouldForceLeadingZeros ? $50d5d6a623389320$var$TWO_DIGIT_FIELD_OPTIONS : $50d5d6a623389320$var$DEFAULT_FIELD_OPTIONS;
  fieldOptions = _objectSpread(_objectSpread({}, defaultFieldOptions), fieldOptions);
  var granularity = options.granularity || 'minute';
  var keys = Object.keys(fieldOptions);
  var _options_maxGranularity;
  var startIdx = keys.indexOf((_options_maxGranularity = options.maxGranularity) !== null && _options_maxGranularity !== void 0 ? _options_maxGranularity : 'year');
  if (startIdx < 0) startIdx = 0;
  var endIdx = keys.indexOf(granularity);
  if (endIdx < 0) endIdx = 2;
  if (startIdx > endIdx) throw new Error('maxGranularity must be greater than granularity');
  var opts = keys.slice(startIdx, endIdx + 1).reduce(function (opts, key) {
    opts[key] = fieldOptions[key];
    return opts;
  }, {});
  if (options.hourCycle != null) opts.hour12 = options.hourCycle === 12;
  opts.timeZone = options.timeZone || 'UTC';
  var hasTime = granularity === 'hour' || granularity === 'minute' || granularity === 'second';
  if (hasTime && options.timeZone && !options.hideTimeZone) opts.timeZoneName = 'short';
  if (options.showEra && startIdx === 0) opts.era = 'short';
  return opts;
}
function $50d5d6a623389320$export$c5221a78ef73c5e9(placeholderValue) {
  if (placeholderValue && 'hour' in placeholderValue) return placeholderValue;
  return new (0, $68Tdx$internationalizeddate.Time)();
}
function $50d5d6a623389320$export$61a490a80c552550(value, calendar) {
  if (value === null) return null;
  if (!value) return undefined;
  return (0, $68Tdx$internationalizeddate.toCalendar)(value, calendar);
}
function $50d5d6a623389320$export$66aa2b09de4b1ea5(placeholderValue, granularity, calendar, timeZone) {
  if (placeholderValue) return $50d5d6a623389320$export$61a490a80c552550(placeholderValue, calendar);
  var date = (0, $68Tdx$internationalizeddate.toCalendar)((0, $68Tdx$internationalizeddate.now)(timeZone !== null && timeZone !== void 0 ? timeZone : (0, $68Tdx$internationalizeddate.getLocalTimeZone)()).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), calendar);
  if (granularity === 'year' || granularity === 'month' || granularity === 'day') return (0, $68Tdx$internationalizeddate.toCalendarDate)(date);
  if (!timeZone) return (0, $68Tdx$internationalizeddate.toCalendarDateTime)(date);
  return date;
}
function $50d5d6a623389320$export$2440da353cedad43(v, granularity) {
  // Compute default granularity and time zone from the value. If the value becomes null, keep the last values.
  var defaultTimeZone = v && 'timeZone' in v ? v.timeZone : undefined;
  var defaultGranularity = v && 'minute' in v ? 'minute' : 'day';
  // props.granularity must actually exist in the value if one is provided.
  if (v && granularity && !(granularity in v)) throw new Error('Invalid granularity ' + granularity + ' for value ' + v.toString());
  var _ref = (0, $68Tdx$react.useState)([defaultGranularity, defaultTimeZone]),
    _ref2 = _slicedToArray(_ref, 2),
    lastValue = _ref2[0],
    setLastValue = _ref2[1];
  // If the granularity or time zone changed, update the last value.
  if (v && (lastValue[0] !== defaultGranularity || lastValue[1] !== defaultTimeZone)) setLastValue([defaultGranularity, defaultTimeZone]);
  if (!granularity) granularity = v ? defaultGranularity : lastValue[0];
  var timeZone = v ? defaultTimeZone : lastValue[1];
  return [granularity, timeZone];
}